import { render, staticRenderFns } from "./seniorEventData.vue?vue&type=template&id=7a2f1449&"
import script from "./seniorEventData.vue?vue&type=script&lang=js&"
export * from "./seniorEventData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a2f1449')) {
      api.createRecord('7a2f1449', component.options)
    } else {
      api.reload('7a2f1449', component.options)
    }
    module.hot.accept("./seniorEventData.vue?vue&type=template&id=7a2f1449&", function () {
      api.rerender('7a2f1449', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data/seniorEventData.vue"
export default component.exports